import { render, staticRenderFns } from "./AddEditSimulation.vue?vue&type=template&id=2ca542a8&"
import script from "./AddEditSimulation.vue?vue&type=script&lang=js&"
export * from "./AddEditSimulation.vue?vue&type=script&lang=js&"
import style0 from "./AddEditSimulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports